module.exports = __webpack_public_path__ + "img/16_debris.bbf16156.jpg";